import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import TextInput from "../../widgets/TextInput";
import MyDatePicker from "../../widgets/DatePicker";
import FixButton from "../../widgets/Button";
import addCorso from "../../services/addCorso";
import moment from 'moment';
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";

let t = translateString;

export default class AddCorso extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      nomeCorso: '',
      anno_accademico: ''
    }

    this.grid = 2;
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    Utils.setAnalyticsPage('Course creation - ' + cookies.get('db', { path: '/' }));

    this.setState({});
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: () => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('crea_corso')} />
          <div style={containerView}>
            <div style={{ display: 'flex' }}>
                <br/>
                <div style={{ display: 'flex', marginTop: '20px' }}>
                    <div>
                      <img alt="" style={{ height: 40, width: 40, marginTop: '25px' }} src={ require( '../../images/info_icon.png' )} />
                    </div>
                    <div className="inputContainer" style={{ marginLeft: '15px' }}>
                        <TextInput name={t('nome')} value={this.state.nomeCorso} 
                          onChange={(text) => { this.setState({nomeCorso: text})}
                        } />

                        <TextInput name={t('anno_accademico')} value={this.state.anno_accademico} 
                          onChange={(text) => { this.setState({anno_accademico: text})}
                        } />
                    </div>
                </div>

                <div style={{ display: 'flex', marginTop: '20px', marginLeft: '30px' }}>
                    <div>
                        <img alt="" style={{ height: 40, width: 40, marginTop: '25px' }} src={ require( '../../images/cal_icon.png' )} />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                        <MyDatePicker ref={this.startDateRef} name={t('data_inizio')}/>
                        <MyDatePicker ref={this.endDateRef} name={t('data_fine')}/>
                    </div>
                </div>
                <br/>
              </div>
              <div style={{ textAlign: 'left', marginTop: '25px' }}>
                  <FixButton title={t('crea')} callback={this.save.bind(this)} />
              </div>
          </div>
        </LoadingOverlay>
      </>
    );
  }

  async save (){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });

      const xStartDate = this.startDateRef.current.getDate();
      const xEndDate = this.endDateRef.current.getDate();

      let startDate = moment(xStartDate).format('yyyy-MM-DD');
      let endDate = moment(xEndDate).format('yyyy-MM-DD');

      if (xEndDate < xStartDate){
        Utils.showInfo(t('controlla_date'));
        return;
      }

      let ret = await addCorso (username, token, this.state.nomeCorso, startDate, endDate, this.state.anno_accademico);

      if (ret.result == 'ok'){
        Utils.showSuccess(t('corso_creato'));
        window.location.href =  '/' + this.dbPath + '/#/app/corsi';
      }
      else {
        Utils.showError(t('errore_imprevisto'));
      }
      
  }

}

const containerView = {

    paddingRight: '40px',
    backgroundColor: 'white', 
    borderRadius: '10px', 
    paddingTop: '5px',
    paddingBottom: '20px',
    paddingLeft: '40px',
    boxShadow: '0px 2px 10px lightgrey', 
}

